import React from 'react';
import { HABU_ENVIRONMENT } from 'utils/appConstants';
import {
  IconButton, Link, Skeleton, Tooltip,
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { useFetchCleanRoomAssetMapping } from 'hooks/cleanRoomAPIs';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';


const LR_CONNECT_LINK = HABU_ENVIRONMENT === 'production' ? 'https://connect.liveramp.com/' : 'https://connect.dev.liveramp.com/';

const LinkToLRConnect = () => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const { crId } = useParams();

  const {
    data: crAsset,
    isLoading,
    isError,
  } = useFetchCleanRoomAssetMapping(orgId, crId);

  if (isLoading) {
    return <Skeleton variant='rectangular' width={24} height={24} />;
  }

  if (isError) {
    return null;
  }

  return (
    <Tooltip
      title='Click to open in LiveRamp Connect'
      arrow
      placement='top'
    >
      <Link
        href={`${LR_CONNECT_LINK}?organization=${crAsset?.liveRampOrganizationID || orgId}`}
        target='_blank'
        rel='noreferrer'
      >
        <IconButton size='small'>
          <OpenInNewIcon />
        </IconButton>
      </Link>
    </Tooltip>
  );
};

export default LinkToLRConnect;
